<template>
  <v-btn
    v-if="
      role(
        'admin',
        'departmentManager',
        'manager',
        'safetyRepresentative'
      )
    "
    @click="toggle"
    class="primary accent-4 white--text mr-2 my-1"
    small
  >
    {{ state ? $t("profile.history.hide") : $t("profile.history.show") }}
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["state"],
  computed: {
    ...mapGetters(["role"]),
  },
  methods: {
    toggle() {
      this.$emit("update:state", !this.state);
    },
  },
};
</script>
